/* ============================================================================
   ORIPAYA · SAKURA COLLECTORS CLUB — Page « Calendrier TCG »
   assets/oripaya-calendrier-page.js
   ============================================================================

   CE FICHIER N'EST QU'UNE AMÉLIORATION. La page filtre déjà sans lui.

   Sans JavaScript :
     · les filtres sont des boutons radio natifs, groupés par <fieldset> et
       <legend>, navigables aux flèches du clavier ;
     · le filtrage est fait par les règles CSS générées par la section
       (`:has(#id:checked)`), donc instantané et sans rechargement ;
     · retirer un filtre est un <label> pointant vers le radio « tous » de
       son groupe ; « Tout effacer » est un vrai lien vers la page.

   Ce que le script ajoute, et rien d'autre :
     1. l'URL partageable — ?jeu=pokemon-tcg&region=jp — posée en pushState,
        relue au chargement et au retour arrière du navigateur ;
     2. le compteur de résultats, rendu masqué côté serveur pour qu'aucun
        chiffre faux ne s'affiche si le script ne s'exécute jamais ;
     3. les combinaisons de filtres, que le CSS généré ne décrit pas : état
        vide, mois devenus vides, puces actives, décompte de l'archive.

   Contraintes tenues :
     · aucune bibliothèque, aucune dépendance ;
     · aucune animation ajoutée — le CSS porte tout le mouvement ;
     · aucun affichage inventé : le script ne fait que compter et masquer ce
       que le serveur a rendu.
   ========================================================================== */

(function () {
  'use strict';

  /* Le paramètre d'URL porte le nom du groupe ; l'attribut de données porte
     un nom court, pour ne pas alourdir 43 lignes de balisage. */
  var GROUPES = {
    jeu: 'data-jeu',
    region: 'data-region',
    categorie: 'data-cat',
    statut: 'data-statut'
  };

  function tableau(liste) {
    return Array.prototype.slice.call(liste || []);
  }

  /* ==========================================================================
     Une page calendrier
     ========================================================================== */
  function CalendrierPage(racine) {
    this.racine = racine;
    this.radios = tableau(racine.querySelectorAll('[data-cp-radio]'));

    if (!this.radios.length) {
      /* Filtres désactivés dans l'éditeur : il n'y a rien à améliorer. */
      return;
    }

    this.items = tableau(racine.querySelectorAll('[data-cp-item]'));
    this.mois = tableau(racine.querySelectorAll('[data-cp-mois]'));
    this.zoneAvenir = racine.querySelector('[data-cp-zone="a_venir"]');
    this.zonePassee = racine.querySelector('[data-cp-zone="passes"]');
    this.actifs = racine.querySelector('[data-cp-actifs]');
    this.compte = racine.querySelector('[data-cp-compte]');
    this.compteNombre = racine.querySelector('[data-cp-compte-nombre]');
    this.compteMot = racine.querySelector('[data-cp-compte-mot]');
    this.compteArchive = racine.querySelector('[data-cp-archive-compte]');
    this.videFiltre = racine.querySelector('[data-cp-vide="filtre"]');
    this.puces = tableau(racine.querySelectorAll('[data-cp-puce]'));
    this.hoteEffacer = racine.querySelector('[data-cp-effacer-hote]');

    this.motUn = this.compte ? this.compte.getAttribute('data-un') || '' : '';
    this.motPlusieurs = this.compte ? this.compte.getAttribute('data-plusieurs') || '' : '';

    this.surChangement = this.changement.bind(this);
    this.surEffacement = this.effacement.bind(this);
    this.surHistorique = this.historique.bind(this);

    this.brancher();
    this.lireUrl();
    this.appliquer(false);

    /* Le compteur n'était rendu que masqué : c'est ici, et seulement ici,
       qu'il devient visible — quand un script est là pour le tenir juste. */
    if (this.compte) {
      this.compte.hidden = false;
    }
    if (this.actifs) {
      this.actifs.classList.add('est-visible');
    }
  }

  CalendrierPage.prototype.brancher = function () {
    var i;
    for (i = 0; i < this.radios.length; i++) {
      this.radios[i].addEventListener('change', this.surChangement);
    }

    var liens = tableau(this.racine.querySelectorAll('[data-cp-effacer]'));
    for (i = 0; i < liens.length; i++) {
      liens[i].addEventListener('click', this.surEffacement);
    }

    window.addEventListener('popstate', this.surHistorique);
  };

  CalendrierPage.prototype.debrancher = function () {
    var i;
    for (i = 0; i < this.radios.length; i++) {
      this.radios[i].removeEventListener('change', this.surChangement);
    }
    var liens = tableau(this.racine.querySelectorAll('[data-cp-effacer]'));
    for (i = 0; i < liens.length; i++) {
      liens[i].removeEventListener('click', this.surEffacement);
    }
    window.removeEventListener('popstate', this.surHistorique);
  };

  /* --------------------------------------------------------------------------
     L'état : ce que les radios cochés disent, et rien d'autre.
     -------------------------------------------------------------------------- */
  CalendrierPage.prototype.etat = function () {
    var etat = { jeu: '', region: '', categorie: '', statut: '' };
    for (var i = 0; i < this.radios.length; i++) {
      var radio = this.radios[i];
      if (!radio.checked) continue;
      var groupe = radio.getAttribute('data-groupe');
      if (Object.prototype.hasOwnProperty.call(etat, groupe)) {
        etat[groupe] = radio.getAttribute('data-valeur') || '';
      }
    }
    return etat;
  };

  CalendrierPage.prototype.cocher = function (groupe, valeur) {
    for (var i = 0; i < this.radios.length; i++) {
      var radio = this.radios[i];
      if (radio.getAttribute('data-groupe') !== groupe) continue;
      if ((radio.getAttribute('data-valeur') || '') === valeur) {
        radio.checked = true;
        return true;
      }
    }
    return false;
  };

  /* --------------------------------------------------------------------------
     L'URL — lecture au chargement, écriture à chaque changement.
     Une valeur inconnue est ignorée en silence : une adresse partagée après
     un renommage de filtre affiche le calendrier entier, jamais une erreur.
     -------------------------------------------------------------------------- */
  CalendrierPage.prototype.lireUrl = function () {
    var recherche = window.location.search;
    if (!recherche || recherche.length < 2) return;

    var paires = recherche.substring(1).split('&');
    for (var i = 0; i < paires.length; i++) {
      var morceaux = paires[i].split('=');
      var cle = decodeURIComponent(morceaux[0] || '').replace(/\+/g, ' ');
      if (!Object.prototype.hasOwnProperty.call(GROUPES, cle)) continue;
      var valeur = decodeURIComponent((morceaux[1] || '').replace(/\+/g, ' '));
      if (valeur) this.cocher(cle, valeur);
    }
  };

  CalendrierPage.prototype.ecrireUrl = function () {
    if (!window.history || !window.history.pushState) return;

    var etat = this.etat();
    var parties = [];
    for (var groupe in GROUPES) {
      if (!Object.prototype.hasOwnProperty.call(GROUPES, groupe)) continue;
      if (etat[groupe]) {
        parties.push(encodeURIComponent(groupe) + '=' + encodeURIComponent(etat[groupe]));
      }
    }

    var url = window.location.pathname + (parties.length ? '?' + parties.join('&') : '');
    if (url === window.location.pathname + window.location.search) return;
    window.history.pushState({ oripayaCalendrier: true }, '', url);
  };

  /* --------------------------------------------------------------------------
     L'application de l'état au balisage rendu par le serveur.
     Le script ne crée aucun contenu : il masque, et il compte.
     -------------------------------------------------------------------------- */
  CalendrierPage.prototype.appliquer = function (ecrire) {
    var etat = this.etat();
    var actif = !!(etat.jeu || etat.region || etat.categorie || etat.statut);
    var i;

    for (i = 0; i < this.items.length; i++) {
      var item = this.items[i];
      var garde = true;
      for (var groupe in GROUPES) {
        if (!Object.prototype.hasOwnProperty.call(GROUPES, groupe)) continue;
        var attendu = etat[groupe];
        if (!attendu) continue;
        if ((item.getAttribute(GROUPES[groupe]) || '') !== attendu) {
          garde = false;
          break;
        }
      }
      item.hidden = !garde;
    }

    /* Un mois sans entrée visible n'a plus de raison d'avoir un intertitre. */
    for (i = 0; i < this.mois.length; i++) {
      this.mois[i].hidden = this.compter(this.mois[i]) === 0;
    }

    var restants = this.zoneAvenir ? this.compter(this.zoneAvenir) : 0;

    if (this.compteNombre) {
      this.compteNombre.textContent = String(restants);
    }
    if (this.compteMot) {
      this.compteMot.textContent = restants <= 1 ? this.motUn : this.motPlusieurs;
    }
    if (this.compteArchive && this.zonePassee) {
      this.compteArchive.textContent = '(' + this.compter(this.zonePassee) + ')';
    }

    /* L'état vide n'apparaît que si un filtre est en cause : sans filtre, un
       calendrier vide a déjà son propre message, rendu par le serveur. */
    if (this.videFiltre) {
      this.videFiltre.classList.toggle('est-visible', actif && restants === 0);
    }

    for (i = 0; i < this.puces.length; i++) {
      var puce = this.puces[i];
      var id = puce.getAttribute('data-cp-puce');
      var radio = id ? document.getElementById(id) : null;
      puce.classList.toggle('est-visible', !!(radio && radio.checked));
    }
    if (this.hoteEffacer) {
      this.hoteEffacer.classList.toggle('est-visible', actif);
    }

    if (ecrire) this.ecrireUrl();
  };

  CalendrierPage.prototype.compter = function (zone) {
    var items = tableau(zone.querySelectorAll('[data-cp-item]'));
    var total = 0;
    for (var i = 0; i < items.length; i++) {
      if (!items[i].hidden) total++;
    }
    return total;
  };

  /* --------------------------------------------------------------------------
     Événements
     -------------------------------------------------------------------------- */
  CalendrierPage.prototype.changement = function () {
    this.appliquer(true);
  };

  CalendrierPage.prototype.effacement = function (evenement) {
    /* Le lien reste un vrai lien : ouvert dans un nouvel onglet ou sans
       script, il recharge la page sans filtre. On n'intercepte que le clic
       simple, celui qu'on sait faire mieux. */
    if (evenement.metaKey || evenement.ctrlKey || evenement.shiftKey || evenement.altKey) return;
    if (evenement.button && evenement.button !== 0) return;

    evenement.preventDefault();
    for (var groupe in GROUPES) {
      if (!Object.prototype.hasOwnProperty.call(GROUPES, groupe)) continue;
      this.cocher(groupe, '');
    }
    this.appliquer(true);
  };

  CalendrierPage.prototype.historique = function () {
    for (var groupe in GROUPES) {
      if (!Object.prototype.hasOwnProperty.call(GROUPES, groupe)) continue;
      this.cocher(groupe, '');
    }
    this.lireUrl();
    this.appliquer(false);
  };

  /* ==========================================================================
     Amorçage — et réamorçage dans l'éditeur de thème.
     ========================================================================== */
  var instances = [];

  function amorcer(perimetre) {
    var racines = tableau((perimetre || document).querySelectorAll('[data-oripaya-calendrier-page]'));
    for (var i = 0; i < racines.length; i++) {
      if (racines[i].hasAttribute('data-cp-amorce')) continue;
      racines[i].setAttribute('data-cp-amorce', 'true');
      instances.push(new CalendrierPage(racines[i]));
    }
  }

  function demarrer() {
    amorcer(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  document.addEventListener('shopify:section:load', function (evenement) {
    amorcer(evenement.target);
  });

  document.addEventListener('shopify:section:unload', function (evenement) {
    for (var i = instances.length - 1; i >= 0; i--) {
      var instance = instances[i];
      if (instance.racine && !document.contains(instance.racine)) {
        if (instance.debrancher) instance.debrancher();
        instances.splice(i, 1);
      }
    }
  });
})();
